import { createContext } from "react";

export const HelmetContext = createContext({});
